/**
 * Build a safe image URL — for Instagram/TikTok CDN URLs we route them
 * through our backend image proxy to bypass hotlink blocking.
 */
const API_BASE = process.env.REACT_APP_BACKEND_URL;
const NEEDS_PROXY = ["cdninstagram.com", "fbcdn.net", "tiktokcdn.com", "tiktokcdn-us.com", "byteoversea.com", "scontent"];

export function proxyImage(url) {
  if (!url || typeof url !== "string") return "";
  if (NEEDS_PROXY.some(h => url.includes(h))) {
    return `${API_BASE}/api/img-proxy?url=${encodeURIComponent(url)}`;
  }
  return url;
}
